import React, { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import VideoUserResponse from './VideoUserResponse';
//import { CleanUrl } from "../../../utils/cleanUrl";
import VotingResults from "./VotingResults";
import ScratchCard from './ScratchCard';

function Confirmation({userResponse, promotionSettings}) {
    const { t } = useTranslation();

    useEffect(() => {
        const handleIframeMessage = (event) => {
            const iframes = document.getElementsByClassName('pweu-iframe');
            for (let i = 0; i < iframes.length; i++) {
                if (event.data && typeof event.data === 'number') {
                    iframes[i].style.height = `${event.data}px`;
                }
            }
        };

        window.addEventListener('message', handleIframeMessage);

        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }, []);

    // Check for the marketing modal and apply the 'open' class with a delay
    useEffect(() => {
        const modal = document.querySelector('.marketing-modal');
        const { result } = userResponse || {};

        if (modal && result) {
            const { user_response = [], questions = [] } = result;

            // Array of response types to check
            const responseTypes = ['giveaway', 'iframe', 'video', 'scratchcard'];

            // Check if any of the response types are present
            const hasResponseType = user_response.some(item =>
                responseTypes.includes(item.response_type)
            );

            const hasQuestions = questions.length > 0;

            if (!hasQuestions && !hasResponseType) {
                const timer = setTimeout(() => {
                    modal.classList.add('open');
                }, 6000);

                return () => clearTimeout(timer);
            }
        }
    }, [userResponse]);

    return (
        <>
            <div className="promo-fields-group">
                <div className="promo-fields">
                    <div className="pweu-confirmation-feedback">

                        {userResponse?.result?.user_response?.map((item, index) => {
                            // console.log("item", item);
                            switch (item.response_type) {
                                // case "ty_text":
                                //     return (
                                //         <div key={index} className="response-ty-text response">
                                //             <h3>{item.response}</h3>
                                //             {item.text && <p>{item.text}</p>}
                                //         </div>
                                //     );
                                case "won":
                                    return (
                                        <Fragment key={index}>
                                            <div className="pweu-emote pweu-emote--won">
                                                <svg width="144" height="102" viewBox="0 0 144 102" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clipPath="url(#clip0_3715_13928)">
                                                        <path d="M38.3827 33.3195C29.1889 33.714 21.4101 26.587 21.0156 17.3846C20.6211 8.19081 27.748 0.412083 36.9504 0.0175723C46.1443 -0.376939 53.923 6.74999 54.3175 15.9524C54.712 25.1462 47.5851 32.9249 38.3913 33.3195" fill="#FBB517" />
                                                        <path d="M107.781 33.3195C98.5873 33.714 90.8086 26.587 90.4141 17.3846C90.0195 8.19081 97.1465 0.412083 106.349 0.0175723C115.543 -0.376939 123.321 6.74999 123.716 15.9524C124.11 25.1462 116.984 32.9249 107.79 33.3195" fill="#FBB517" />
                                                        <path d="M0.20347 61.0594L23.6115 43.6166C28.3531 52.7545 35.7642 60.6281 45.4729 65.9375C71.4667 80.1575 104.07 70.6161 118.298 44.6138C118.328 44.555 118.351 44.5048 118.382 44.4461L143.771 58.3449C143.741 58.4036 143.71 58.4542 143.687 58.5126C121.79 98.5323 71.602 113.224 31.5826 91.3348C18.1112 83.9643 7.51154 73.3823 0.211998 61.0673" fill="#FBB517" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_3715_13928">
                                                            <rect width="144" height="102" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </div>
                                            <div className="response">
                                                <h3>{item.response}</h3>
                                                {item.text && <p>{item.text}</p>}
                                            </div>
                                        </Fragment>
                                    );
                                case "participated":
                                    return (
                                        <Fragment key={index}>
                                            <div className="pweu-emote pweu-emote--participated">
                                                <svg width="144" height="102" viewBox="0 0 144 102" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_3715_13928)">
                                                        <path d="M38.3827 33.3195C29.1889 33.714 21.4101 26.587 21.0156 17.3846C20.6211 8.19081 27.748 0.412083 36.9504 0.0175723C46.1443 -0.376939 53.923 6.74999 54.3175 15.9524C54.712 25.1462 47.5851 32.9249 38.3913 33.3195" fill="#FBB517" />
                                                        <path d="M107.781 33.3195C98.5873 33.714 90.8086 26.587 90.4141 17.3846C90.0195 8.19081 97.1465 0.412083 106.349 0.0175723C115.543 -0.376939 123.321 6.74999 123.716 15.9524C124.11 25.1462 116.984 32.9249 107.79 33.3195" fill="#FBB517" />
                                                        <path d="M0.20347 61.0594L23.6115 43.6166C28.3531 52.7545 35.7642 60.6281 45.4729 65.9375C71.4667 80.1575 104.07 70.6161 118.298 44.6138C118.328 44.555 118.351 44.5048 118.382 44.4461L143.771 58.3449C143.741 58.4036 143.71 58.4542 143.687 58.5126C121.79 98.5323 71.602 113.224 31.5826 91.3348C18.1112 83.9643 7.51154 73.3823 0.211998 61.0673" fill="#FBB517" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id="clip0_3715_13928">
                                                            <rect width="144" height="102" fill="white" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </div>
                                            <div className="response">
                                                <h3>{item.response}</h3>
                                                {item.text && <p>{item.text}</p>}
                                            </div>
                                        </Fragment>
                                    );
                                case "text":
                                    return (
                                        <div key={index} className="response-text response">
                                            <h3 className="prize-title-headline">{item.text} <span className="prize-title">{item.prize_title_public && item.prize_title_public.trim() !== '' ? item.prize_title_public : item.prize_title}</span></h3>
                                            {item.response && <p dangerouslySetInnerHTML={{ __html: item.response }} />}
                                        </div>
                                    );
                                case "image":
                                    return (
                                        <div key={index} className="response-image response">
                                            <h3 className="prize-title-headline">{item.text} <span className="prize-title">{item.prize_title_public && item.prize_title_public.trim() !== '' ? item.prize_title_public : item.prize_title}</span></h3>
                                            <img src={item.response} alt={item.prize_title} />
                                        </div>
                                    );
                                case "video":
                                    return (
                                        <div key={index} className="response-video response">
                                            <h3 className="prize-title-headline">{item.text} <span className="prize-title">{item.prize_title_public && item.prize_title_public.trim() !== '' ? item.prize_title_public : item.prize_title}</span></h3>
                                            <VideoUserResponse videoSrc={item.response} modalResponse={item.text} modalPrizeTitle={item.prize_title_public && item.prize_title_public.trim() !== '' ? item.prize_title_public : item.prize_title} />
                                        </div>
                                    );
                                case "iframe":
                                    return (
                                        <div key={index} className="response-iframe response">
                                            <iframe src={item.response} title={item.prize_title_public && item.prize_title_public.trim() !== '' ? item.prize_title_public : item.prize_title} allow="clipboard-write; microphone" className="pweu-iframe" />
                                        </div>
                                    );
                                case "giveaway":
                                    return (
                                        <div key={index} className="response-giveaway response">
                                            <p>{item.response}</p>
                                            <img src={item.prize_image} alt={item.prize_title} />
                                            <a href={item.wallpaper ? item.wallpaper : item.prize_image} download={item.prize_title} target="_blank" rel="noreferrer" className="btn btn-secondary btn--download">
                                                <span>{t("Download now")}</span>
                                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.5 9.5L2.4375 5.75L3.575 4.6625L5.6875 6.6125V0.5H7.3125V6.6125L9.425 4.6625L10.5625 5.75L6.5 9.5ZM1.625 12.5C1.17813 12.5 0.795708 12.3532 0.47775 12.0597C0.159792 11.7662 0.000541667 11.413 0 11V8.75H1.625V11H11.375V8.75H13V11C13 11.4125 12.841 11.7657 12.5231 12.0597C12.2051 12.3537 11.8224 12.5005 11.375 12.5H1.625Z" fill="#1443FF" />
                                                </svg>
                                            </a>
                                        </div>
                                    );
                                case "hashting":
                                    return (
                                        <div key={index} className="response-hashting response">
                                            <h3 className="prize-title-headline">{item.text} <span className="prize-title">{item.prize_title_public && item.prize_title_public.trim() !== '' ? item.prize_title_public : item.prize_title}</span></h3>
                                            <p>{item.response}</p>
                                            <a href={item.response_link} className="btn btn-primary btn--center" target="_blank" rel="noreferrer">{item.response_link_text}</a>
                                        </div>
                                    );
                                case "url_prize":
                                    return (
                                        <div key={index} className="response-url response">
                                            <h3 className="prize-title-headline">{item.text} <span className="prize-title">{item.prize_title}</span></h3>
                                            <p>{item.response}</p>
                                            <a href={item.response_link} className="btn btn-primary btn--center mt-2" target="_blank" rel="noreferrer">{item.response_link_text}</a>
                                        </div>
                                    );
                                case "scratchcard":
                                    return (
                                        <div key={index} className="response-scratchcard response">
                                            <ScratchCard coverImage={item.response_cover_image} revealImage={item.response} headline={item.text} />
                                        </div>
                                    )
                                case "none":
                                    return (
                                        <div key={index} className="response-default response">
                                            <h3 className="prize-title-headline">{item.text} <span className="prize-title">{item.prize_title_public && item.prize_title_public.trim() !== '' ? item.prize_title_public : item.prize_title}</span></h3>
                                            {item.response && <p dangerouslySetInnerHTML={{ __html: item.response }} />}
                                        </div>
                                    );
                                default:
                                    return null;
                            }
                        })}

                        <VotingResults votingResults={userResponse?.result?.voting} />

                    </div>
                </div>
            </div>
        </>
    );
}

export default Confirmation;
